export const retry = (fn, retriesLeft = 3) =>
  new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch(error => {
        if (retriesLeft === 1) {
          reject(error);
          return;
        }

        retry(fn, retriesLeft - 1).then(resolve, reject);
      });
  });
